module.exports = __webpack_public_path__ + "img/icon.8a7e05ba.png";